const HREF_PATTERN = /href\s*=\s*['"]([^'"]+)['"]/i;
const FILE_PARAM_PATTERN = /[?&]arq=([^&]+)/i;
const PDF_FILE_PATTERN = /\.pdf$/i;
const ABSOLUTE_URL_PATTERN = /^https?:\/\//i;

export const DEFAULT_PDF_FILE_NAME = 'minuta-calculo.pdf';

function decodeHtmlEntities(value) {
  return String(value)
    .replace(/&amp;/gi, '&')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");
}

export function extractPdfHref(message) {
  if (!message) return null;

  const match = String(message).match(HREF_PATTERN);
  if (!match) return null;

  const href = decodeHtmlEntities(match[1]).trim();
  return href === '' || href === '#' ? null : href;
}

export function extractPdfFileName(href) {
  if (!href) return DEFAULT_PDF_FILE_NAME;

  const decoded = decodeHtmlEntities(href);
  const fileParam = decoded.match(FILE_PARAM_PATTERN);
  const source = fileParam ? decodeURIComponent(fileParam[1]) : decoded.split('?')[0];
  const fileName = source.split('/').pop();

  return fileName && PDF_FILE_PATTERN.test(fileName) ? fileName : DEFAULT_PDF_FILE_NAME;
}

export function isAbsoluteUrl(url) {
  return ABSOLUTE_URL_PATTERN.test(String(url || ''));
}

export function normalizeDownloadPath(href) {
  const path = String(href || '').trim();
  if (path === '') return '';

  return path.charAt(0) === '/' ? path : '/' + path;
}
